<template>
  <div class="pa-3 d-flex h-full">
    <div>
      <OSimpleDialog
        :maxWidth="300"
        ref="helpDialog"
        title="Legenda"
        :showButtons="false"
      >
        <v-card-text class="pa-6">
          A intensidade da cor reflete a quantidade de alarmes e vídeos gravadas
          pela câmera no dia:

          <div class="helpDialogItem level-0 mt-4">
            0 (não há dados)
          </div>
          <div class="helpDialogItem level-1">
            Entre 1 e 10 (poucos)
          </div>
          <div class="helpDialogItem level-2">
            Entre 11 e 20 (alguns)
          </div>
          <div class="helpDialogItem level-3">
            Mais de 20 (bastante)
          </div>
        </v-card-text>
      </OSimpleDialog>

      <OJsonDialog ref="jsonDialog" />

      <OCalendarHeatmap
        class="alarmsCalendarHeatmap"
        :curMonth="currentMonth"
        :isLoading="monthDataLoader.isLoading"
        :monthData="currentMonthData"
        @prev="navigate(-1)"
        @next="navigate(+1)"
        @dateClick="selectDate"
        :showHelpIcon="true"
        @helpClick="() => $refs.helpDialog.open()"
        :selectedDate="selectedDate"
      />

      <!-- <Locations class="mt-4" :data="points" /> -->
    </div>

    <div class="flex-grow-1 ml-3 d-flex flex-column justify-stretch h-full">
      <FilesInCamera
        ref="filesInCamera"
        class="mb-4"
        :cameraDef="cameraDef"
        :date="selectedDate"
        @reload="reloadBothPanels"
      />

      <FilesInServer
        ref="filesInServer"
        class="flex-auto h-0 scroll-y"
        :cameraDef="cameraDef"
        :date="selectedDate"
        @reload="reloadBothPanels"
      />
    </div>
  </div>
</template>

<script>
import EditStore from '../EditStore'
import moment from 'moment'
import OCalendarHeatmap from 'oderon-vue/cpts/OCalendarHeatmap.vue'
import Loader from 'oderon-vue/models/Loader.mjs'
import OSimpleDialog from 'oderon-vue/cpts/dialogs/OSimpleDialog.vue'
import OJsonDialog from 'oderon-vue/cpts/dialogs/OJsonDialog.vue'
import FilesInCamera from './FilesInCamera.vue'
import FilesInServer from './FilesInServer.vue'
// import { calendarLimits } from 'oderon-vue/cpts/OCalendarHeatmap.vue'

export default {
  tabTitle: 'Alarmes e Vídeos',
  components: {
    OCalendarHeatmap,
    OSimpleDialog,
    OJsonDialog,
    FilesInCamera,
    FilesInServer
  },
  data() {
    return {
      currentMonth: moment().format('YYYY-MM-DD'),
      currentMonthData: null,
      monthDataLoader: new Loader(),

      selectedDate: null
    }
  },
  computed: {
    currentTab() {
      return EditStore.currentTab
    },
    cameraDef() {
      return EditStore.row
    }
  },
  watch: {
    currentTab: {
      handler(x) {
        if (x == 'alarmsAndVideos') this.reload()
      },
      immediate: true
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchMonthData(this.currentMonth))
      this.$nextTick(() =>
        this.selectDate({ date: moment().format('YYYY-MM-DD') })
      )
    },

    async navigate(x) {
      let monthToLoad = moment(this.currentMonth)
        .add(x, 'month')
        .format('YYYY-MM-DD')

      await this.fetchMonthData(monthToLoad)
      this.currentMonth = monthToLoad
    },

    async fetchMonthData(/*strMonth*/) {
      // await this.monthDataLoader.follow(async () => {
      //   let { start, end } = calendarLimits(strMonth)
      //   let ps = {
      //     cameraId: EditStore.row.id,
      //     fromDate: start,
      //     untilDate: utils.sod(end, +1)
      //   }
      //   this.currentMonthData = await Camera.findDailyEventStats(ps)
      // })
    },

    // click em dia do calendar
    selectDate(calendarDay) {
      this.selectedDate = calendarDay.date
      this.$nextTick(() => this.reloadBothPanels())
    },

    reloadBothPanels() {
      this.$refs.filesInCamera.reload()
      this.$refs.filesInServer.reload()
    }
  }
}
</script>

<style lang="sass">
$color0: #FFF3E0
$color1: #BBDEFB
$color2: #64B5F6
$color3: #1976D2

.alarmsCalendarHeatmap .calendar-day
  border-radius: 4px
  background-color: $color0

  &.level-1
    background-color: $color1

  &.level-2
    background-color: $color2

  &.level-3
    background-color: $color3

  &.active
    border: 3px solid black
    border-radius: 100px

.helpDialogItem
  margin-bottom: 4px

  &::before
    content: ''
    width: 24px
    height: 24px
    display: block
    margin-right: 4px
    float: left
    border-radius: 4px
    border: 1px solid #ccc

  &.level-0::before
    background-color: $color0
  &.level-1::before
    background-color: $color1
  &.level-2::before
    background-color: $color2
  &.level-3::before
    background-color: $color3
</style>
